<div id="main-content">
  <div class="container-fluid">
    <app-breadcrumb [dataInput]="breadCrumb"></app-breadcrumb>


    <div class="row clearfix">
      <div class="col-lg-12">
        <div class="card">
          <div class="header">
            <h2>Transaction Agent Report</h2>
          </div>
          <div class="body">
            <div class="text-center mt-1 mb-3" *ngIf="loadingData"><span class="fa fa-spin fa-spinner fa-2x"></span>&nbsp; Loading, Please wait...</div>
            <div class="table-responsive">
              <table id="transaction-reports" class="table table-bordered table-hover table-striped dataTable" cellspacing="0" width="100%">
                <thead>
                <tr >
                  <th class="no-sort" width="5%"></th>
                  <th>#</th>
                  <!--<th>Action</th>-->

                  <th>Trans Type</th>
                  <th>Payment Channel</th>
                  <th>Status</th>

                  <th>Initiator</th>
                  <th>Recipient</th>
                  <th>Amount</th>

                  <th>Narration</th>

                  <th>Trans Ref.</th>

                </tr>
                </thead>
                <tfoot>
                <tr >
                  <th class="no-sort"></th>
                  <th>#</th>
                  <!--<th>Action</th>-->

                  <th>Trans Type</th>
                  <th>Payment Channel</th>
                  <th>Status</th>

                  <th>Initiator</th>
                  <th>Recipient</th>
                  <th>Amount</th>

                  <th>Narration</th>

                  <th>Trans Ref.</th>

                </tr>
                </tfoot>
                <tbody>
                <tr *ngFor="let trans of agents;let i = index;">

                  <td class="details-control" [id]="'td-' + i" ></td>
                  <td>{{ i + 1 }}</td>
                 <!-- <td>
                    <div>
                                        <span role="button" data-balloon="View Transaction" data-balloon-pos="up" >
                                          <i class="fa fa-eye text-info"></i>
                                        </span>
                    </div>
                  </td>-->
                  <td>{{ trans?.transaction_type?.transaction_type }}</td>
                  <td>{{ trans?.payment_channel?.payment_channel }}</td>
                  <td>
                    <span class="badge badge-success" *ngIf="trans?.transaction_status === 'Successful'">{{ trans?.transaction_status }}</span>
                    <span class="badge badge-danger" *ngIf="trans?.transaction_status !== 'Successful'">{{ trans?.transaction_status }}</span>
                  </td>
                  <td>{{ trans?.initiator?.full_name }}<{{trans?.initiator?.username}}></td>
                  <td>{{ trans?.recipient?.full_name }}<{{trans?.recipient?.username}}></td>
                  <td>{{ trans?.amount | currency: '&#8358;' }}</td>

                  <td>{{ trans?.narration}}</td>

                  <th>{{ trans?.transaction_reference }}</th>



                </tr>
                </tbody>

              </table>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>
</div>
